/**
 * Available reports for the car report.
 */
export enum TypeOfReport {
  DE = 'dE',
  DLABCH = 'dLabCH',
  DLABCH_AVERAGE_PLOT = 'dLabCH with average plot',
}
